module.exports = __webpack_public_path__ + "img/across back.7fd23d2b.png";